'use client';

import { FAQSection } from 'components/shared/FAQSection';
import {
  HeroSectionV2,
  ImagesCarouselSection,
  ImageTitleCtaSection,
  ProgressTabsSection,
  VideoSectionsWithPhone,
  VioBanner,
} from 'components/womens-health';
import { CnOComparison } from 'components/womens-health/CnOComparison';
import { CtaSection } from 'components/womens-health/CtaSection';
import { Disclaimer } from 'components/womens-health/Disclaimer';
import { EncryptionSection } from 'components/womens-health/Encryption';
import { WhitepaperSection } from 'components/womens-health/Whitepaper';
import { useRouter, useSearchParams } from 'next/navigation';

import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import {
  womensHealthFaqDataPro,
  womensHealthFaqDataPlus,
} from 'content/womensHealthFaqData';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import useIsCnOPlus from 'hooks/pricing/useIsCnOPlus';

const WomensHealth = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { region: country, regionSlug } = useRegionLocale();
  const { getValue, isCnOPlus } = useIsCnOPlus();

  const handleUHAppClick = () => {
    const qs = searchParams?.toString();
    router.push(`/${regionSlug}/ring/buy${qs ? `?${qs}` : ''}`);
  };
  return (
    <main>
      <HeroSectionV2 />

      <VideoSectionsWithPhone
        sections={[
          {
            id: 'section-1',
            title: getValue(
              'Confirms ovulation with over 90% accuracy ',
              'Provides consistent, science-informed estimates of your ovulation ',
            ),
            subtitle: getValue(
              'and detects when it hasn’t happened.',
              'and when it may or may not have happened. ',
            ),
            ctaText: country !== 'US' ? 'Buy Ring' : undefined,
            videoSrc: getCompressedAssetUrl(
              getValue(
                '/web_v2/womens-health/videos/mockup_ovulation_confirmed-v2.mp4',
                '/web_v2/womens-health/plus/videos/mockup_ovulation_possible-v2.mp4',
              ),
            ),
            backgroundColor: '#9454ff',
            onClick: handleUHAppClick,
          },
          {
            id: 'section-2',
            title: 'Works for all types of cycles, ',
            subtitle: 'from clockwork to unpredictable.',
            ctaText: country !== 'US' ? 'Buy Ring' : undefined,
            videoSrc: getCompressedAssetUrl(
              getValue(
                '/web_v2/womens-health/videos/mockup_cycle_flags-v3.mp4',
                '/web_v2/womens-health/plus/videos/cycle-plus.mp4',
              ),
            ),
            backgroundColor: '#b44054',
            onClick: handleUHAppClick,
          },
          {
            id: 'section-3',
            title: getValue(
              'Predict up to 12 cycles ',
              'Estimates up to 12 cycles ',
            ),
            subtitle: 'and track changes in ovulation and cycle health.',
            ctaText: country !== 'US' ? 'Buy Ring' : undefined,
            videoSrc: getCompressedAssetUrl(
              getValue(
                '/web_v2/womens-health/videos/mockup_guidance-v2.mp4',
                '/web_v2/womens-health/plus/videos/guidance.mp4',
              ),
            ),
            backgroundColor: 'rgba(148, 84, 255, 1)',
            onClick: handleUHAppClick,
          },
        ]}
      />

      <ImageTitleCtaSection />

      <ImagesCarouselSection />

      {isCnOPlus ? null : <VioBanner />}

      <ProgressTabsSection />

      <CnOComparison />

      <WhitepaperSection />

      <EncryptionSection />

      <CtaSection handleCta={handleUHAppClick} />

      <FAQSection
        faqData={getValue(womensHealthFaqDataPro, womensHealthFaqDataPlus)}
        htmlId="ring-faq"
        bgColor="grey"
        pb="pb-0"
      />

      <Disclaimer />
    </main>
  );
};

export default WomensHealth;
